import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=06f5cde5&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=06f5cde5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5cde5",
  null
  
)

export default component.exports